import styled from "styled-components"

export interface StyledProgramProps {
  degree: string
  header_image: string
}

export interface StyledCardButtonsProps {
  button_position: string
  background_color: string
}

export const StyledProgram = styled.div`
  background: ${(props) => props.theme.colors.white};
`

export const StyledProgramCard = styled.div`
  background: ${(props) => props.theme.colors.white};
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 16px ${(props) => props.theme.colors.darkGrey10};
`

export const StyledProgramHeader = styled.div<StyledProgramProps>`
  ${(props) =>
    props.degree === "Undergraduate" &&
    `background-color: ${props.theme.colors.undergraduate}; `}
  ${(props) =>
    props.degree === "Masters" &&
    `background-color: ${props.theme.colors.masters};`}
  ${(props) =>
    props.degree === "MBA" && `background-color: ${props.theme.colors.mba};`}
  ${(props) =>
    props.degree === "Doctorate" &&
    `background-color: ${props.theme.colors.doctorate};`}
  ${(props) =>
    props.degree === "Executive" &&
    `background-color: ${props.theme.colors.executive};`}
  ${(props) => props.degree && `padding: 16px 24px;`}

  ${(props) =>
    props.header_image &&
    `
      background-image: url(${props.header_image});
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      padding: 16px 24px;
    `}
`

export const StyledProgramHeading = styled.div`
  ${(props) => props.theme.mixins.body};
  color: ${(props) => props.theme.colors.white};
`

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 24px;
`

export const StyledInfo = styled.div``

export const StyledProgramTitle = styled.p`
  ${(props) => props.theme.mixins.subsectionTitle};
`
export const StyledProgramDescription = styled.div`
  margin: 16px 0 0;

  & p {
    ${(props) => props.theme.mixins.body}

    & a {
      ${(props) => props.theme.mixins.link}
    }
    & strong {
      ${(props) => props.theme.mixins.bold}
    }
  }
`

export const StyledAttributes = styled.div`
  margin: 24px 0;
`

export const StyledAttribute = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
  p {
    color: ${(props) => props.theme.colors.ivoryDark};
  }

  &:nth-of-type(1) {
    margin-top: 0;
  }
`

export const StyledButtonContainer = styled.div`
  display: flex;
  gap: 24px;
`

export const StyledCardButtons = styled.div<StyledCardButtonsProps>`
  display: flex;
  ${(props) =>
    props.button_position === "left" &&
    `
        justify-content: flex-start;
    `}
  ${(props) =>
    props.button_position === "right" &&
    `
        justify-content: flex-end;
    `}
    ${(props) =>
    props.button_position === "full" &&
    `
        width: 100%;

        & a, & button{
            width: 100%;
        }
    `}

    & .button-v2--text, & .button-v2--text-alt {
    padding-top: 0;
    padding-bottom: 0;
    min-height: 0;

    ${(props) =>
      props.background_color === "charcoal" &&
      `
      color: ${props.theme.colors.white};
    `}
  }
`

export const StyledIcon = styled.div<StyledProgramProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  max-width: 18px;
  min-width: 18px;
  margin-right: 16px;

  svg {
    ${(props) =>
      props.degree === "Undergraduate" &&
      `color: ${props.theme.colors.undergraduate}; `}
    ${(props) =>
      props.degree === "Masters" && `color: ${props.theme.colors.masters};`}
    ${(props) => props.degree === "MBA" && `color: ${props.theme.colors.mba};`}
    ${(props) =>
      props.degree === "Doctorate" && `color: ${props.theme.colors.doctorate};`}
    ${(props) =>
      props.degree === "Executive" && `color: ${props.theme.colors.executive};`}
  }
`
